<template>
    <el-dialog
        :visible.sync="showClassInfo"
        top="13vh"
        width="600px"
        title="培训班附件下载"
        class=" detail-info-dia"
    >
        <div class="InfoWrap">
            <div class="classInfo">
                <div class="row" v-if="classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train' || classInfo.class_train_type === 'goalkeeper_train'">
                    <div class="col">
                        <p>培训手册：<span class="load" @click="loadNotice('manual')" :disabled="noticeBtnDis">点击下载</span></p>
                    </div>
                    <div class="col">
                        <p>录取通知：<span class="load" @click="loadNotice('notification')" :disabled="noticeBtnDis">点击下载</span></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p>学员帐号：<span class="load" @click="loadStuAcc" :disabled="accBtnDis">点击下载</span></p>
                    </div>
                    <div class="col">
                        <p>学员尺码信息：<span class="load" @click="loadStuDressSize" :disabled="accBtnDisDressSize">点击下载</span></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p>签到表：<span class="load" @click="loadStuSignSheet" :disabled="accBtnDisSheet">点击下载</span></p>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {area_name} from "@/assets/js/region";
    import {
      getClassDown,
      getClass_manual_down,
      loadStuDressSizeAjax,
      loadSignSheetAjax,
      loadStuAccountAjax,
    } from "@/api/agency/agency";
    import { correctStatus } from "@/assets/js/apiStatus";
    import commonFun from "@/assets/js/yioks";
    const { downfile } = commonFun;
    export default {
        name: "classInfoDetail",
        props:{
            isShow:{
                type:Boolean,
                required:true,
                default:false,
            },
            classInfo:{
                type: Object,
                required: true,
            },
        },
      data() {
        return {
          noticeBtnDis: false,
          accBtnDis: false,
          accBtnDisSheet: false,
          accBtnDisDressSize: false,
        }
      },
        computed:{
            showClassInfo:{
                get(){
                    return this.isShow;
                },
                set(val){
                  this.$emit('update:isShow',val)
                },
            }
        },
        filters:{
            getArea(id) {
                return area_name[id];
            },
        },
      methods: {
        // 下载通知
        loadNotice(type) {
          if (this.noticeBtnDis) return;
          this.noticeBtnDis = true;
          let ajx = getClassDown;
          if(this.classInfo.class_the_quality === 'eleven' && type ==='manual'){
            ajx = getClass_manual_down;
          }
          ajx({ c_id: this.classInfo.c_id, type: type }).then(({ data }) => {
            if (data.status === correctStatus) {
              downfile(data.result.file_url);
            } else {
              this.$message.error(`下载失败, ${data.msg}`);
            }
            this.noticeBtnDis = false;
          });
        },
        loadStuDressSize() {
          if (this.accBtnDisDressSize) return;
          this.accBtnDisDressSize = true;
          loadStuDressSizeAjax({ c_id: this.classInfo.c_id }).then(
            ({ data }) => {
              if (data.status === correctStatus) {
                downfile(data.result.file_url);
              } else {
                this.$message.error(`下载失败, ${data.msg}`);
              }
              this.accBtnDisDressSize = false;
            }
          );
        },
        loadStuSignSheet() {
          if (this.accBtnDisSheet) return;
          this.accBtnDisSheet = true;
          loadSignSheetAjax({ c_id: this.classInfo.c_id }).then(
            ({ data }) => {
              if (data.status === correctStatus) {
                downfile(data.result.file_url);
              } else {
                this.$message.error(`下载失败, ${data.msg}`);
              }
              this.accBtnDisSheet = false;
            }
          );
        },
        // 下载学员帐号时执行
        loadStuAcc() {
          if (this.accBtnDis) return;
          this.accBtnDis = true;
          loadStuAccountAjax({ c_id: this.classInfo.c_id, type: "notification" }).then(
            ({ data }) => {
              if (data.status === correctStatus) {
                downfile(data.result.file_url);
              } else {
                this.$message.error(`下载失败, ${data.msg}`);
              }
              this.accBtnDis = false;
            }
          );
        },
      }
    }
</script>

<style  lang="stylus">
    @import '~@/assets/css/variable';
    .InfoWrap {
        .classInfo {
            font-size: 15px
            margin-bottom 5px
            border: 1px solid #606266;
            .row {
                height: 40px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #606266;
                .col {
                    flex: 1 0 auto;
                    display: flex;
                    .tip {
                        margin: 0 0 0 30px;
                    }
                    .load{
                        cursor:pointer;
                        color:#4cd964;
                    }
                }
                .col:first-child {
                    width: 45%;
                    padding: 0 0 0 10px;
                }
                .col:last-child {
                    width: 55%;
                }
            }
            .row:last-child {
                border-bottom: none;
            }
        }
    }
</style>
